import { useScopedTranslation } from 'application/localization/useScopedTranslation';
import SearchIcon from 'assets/icons/search.svg?react';
import { ChangeEvent } from 'react';
import { Input } from './Input';

import styles from './SearchInput.module.scss';
import clsx from 'clsx';

type SearchInputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  className?: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
};

export const SearchInput: React.FC<SearchInputProps> = ({
  className,
  onChange,
  ...rest
}) => {
  const i18n = useScopedTranslation('Component.SearchInput');
  return (
    <Input
      testId="search-input"
      className={clsx(styles.searchInput, className)}
      placeholder={i18n.t('search')}
      endAdornment={<SearchIcon />}
      endAdornmentClassname={styles.searchIcon}
      onChange={(e) => onChange(e)}
      {...rest}
    />
  );
};
